import { PublicConfig } from '../../../../../functions/src/shared';

interface Props {
  missingKeys: (keyof PublicConfig)[];
}

export const MissingConfiguration = ({ missingKeys }: Props) => {
  const isMissingPrivacyPolicy = missingKeys.includes('privacyPolicyUrl');

  return (
    <div className="box order-lookup-box missing-configuration-box">
      <h1>Missing Configuration</h1>
      <p>The app is not fully configured. Please use your admin panel to provide the following:</p>
      <ul>{isMissingPrivacyPolicy && <li>Privacy Policy URL</li>}</ul>
    </div>
  );
};
